import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { tomoIncludes, tomos } from '../../data/landing';
export function Tomos() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-252" data-mp="7xcqk68gnybx">
      <div className="mx-auto max-w-6xl" data-id="element-253" data-mp="7xuqbcuc0uol">
        <div className="mx-auto max-w-3xl text-center" data-id="element-254" data-mp="cwpaoj7y6rat">
          <TrophyIcon className="mx-auto h-10 w-10 text-gold-strong" aria-hidden="true" data-id="element-255" data-mp="cy8qy9tlt2cl" />
          <h2 className="mt-4 text-3xl font-black uppercase leading-[1.1] tracking-tight text-brand md:text-5xl" data-id="element-256" data-mp="3bfmf6id68yik">
            MegaPack Colon Tranquilo <Highlight data-id="element-257" data-mp="3lc90175hzpkl">en 7 Días™</Highlight>
          </h2>
          <p className="mt-5 text-xl font-bold text-charcoal" data-id="element-258" data-mp="3lao3jbzmhwk3">5 Tomos + 5 Bonos — Días 1 → 7</p>
          <p className="mt-1 text-lg text-muted" data-id="element-259" data-mp="3qcn5qijmmnfg">420+ páginas — Todo resuelto.</p>
        </div>

        <h3 className="mt-14 text-center text-sm font-bold uppercase tracking-[0.2em] text-brand" style={{
        fontSize: "16px"
      }} data-id="element-260" data-mp="10l8fupvpanyo">
          5 Tomos completos
        </h3>

        <ol className="mt-8 space-y-4" data-id="element-261" data-mp="1hrh4ylkyrqmz">
          {tomos.map(t => <li key={t.number} className="grid grid-cols-[auto_1fr] items-center gap-5 rounded-3xl bg-white p-5 shadow-sm md:grid-cols-[auto_240px_1fr] md:gap-8 md:p-6" data-id="element-262" data-mp="1ctnx7o40iokl">
              <span className="flex h-16 w-14 flex-col items-center justify-center rounded-lg text-white shadow-md md:h-20 md:w-16" style={{
            backgroundColor: t.color
          }} aria-hidden="true" data-id="element-263" data-mp="18u6swy0bnxh0">
                <span className="text-[10px] font-bold uppercase tracking-wider opacity-90" data-id="element-264" data-mp="yvr2kx94cs8k">Tomo</span>
                <span className="text-2xl font-black leading-none md:text-3xl" data-id="element-265" data-mp="u1d4gn32o707">{t.number}</span>
              </span>
              <div data-id="element-266" data-mp="l2rnuxh5v222">
                <p className="text-sm font-bold uppercase tracking-wider" style={{
              color: t.color
            }} data-id="element-267" data-mp="l3av9k96q81u">
                  {t.days}
                </p>
                <p className="text-lg font-extrabold leading-tight text-brand md:text-xl" data-id="element-268" data-mp="b4lmcgz9nxxq">
                  {t.title}
                </p>
              </div>
              <p className="col-span-2 text-base text-charcoal md:col-span-1" data-id="element-269" data-mp="1femtg120pn7">{t.description}</p>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-brand p-7 md:p-10" data-id="element-270" data-mp="6dg9eaxov73f">
          <p className="text-xl font-extrabold text-white" data-id="element-271" data-mp="3nph93zvs3z7w">Cada tomo incluye:</p>
          <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-272" data-mp="3so2cu9a8p113">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base text-white" data-id="element-273" data-mp="k88udowclfhe">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-274" data-mp="p6k1vsz67dwg">
                  <CheckIcon className="h-3.5 w-3.5 text-brand" strokeWidth={3.5} aria-hidden="true" data-id="element-275" data-mp="agcwoey6brdp" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}